
var showAnswer = function(exam,global) {

    var answer = global.response.answers[global.questionIndex];
    var question = answer.question;
    var correctChoice = question.correct_choice;
    var answer_text = question['choice_' + correctChoice];
    var incorrect_explanation = '';
    var reference = '';
    var explanation = question.explanation;
    if ( question.other_explanation !== null) {
        explanation += '<br><br>' + question.other_explanation;
    }
    if ( question.reference !== null) {
        reference = '<br><br>Reference: ' + question.reference;
    }

    var modalDiv = $('#'+ global.modal);
    $(modalDiv).on('hidden.bs.modal', function (e) {
        $(modalDiv).find('.modal-content').html('');
    });
    var i = 0;
    var modalcontentstr = '<div class="modal-header">Answer</div><div class="modal-body">' +
        'Correct choice: ' + correctChoice + '. ' + answer_text + '<br><br/>Explanation: ' + explanation + reference +
        '</div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div>';
    var modalContent = $.parseHTML(modalcontentstr);
    $(modalDiv).find('.modal-content').append(modalContent);
    $(modalDiv).modal();

}

module.exports = showAnswer;



//////////////////
// WEBPACK FOOTER
// ./src/quiz_show_answer.js
// module id = 328
// module chunks = 0